module.exports = __webpack_public_path__ + "app-dev.2AF2x30n.svg";